import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    teacherGradeState,
    teacherIdState,
    teacherNameState,
    teacherSemesterState
} from "../../recoil/teacher/teacherIdState";
import {getHomeData, getStudents} from "../../network/Endpoint";
import {useEffect, useState} from "react";
import {authState} from "../../recoil/auth/authState";
import {useNavigate} from "react-router-dom";
import AddStudentBtn from "../../assets/images/add_studentBtn.png"
import BoardImg from "../../assets/images/board_ico.png"
import OpenBookImg from "../../assets/images/open_book.png"
import HomeStageBadge from "./HomeStageBadge";
import { topMenuTypeState} from "../../recoil/menuState/topMenuState";
import {mainClassState} from "../../recoil/classes/classesState";
import ShowNextBtn from "../../assets/images/show_next_btn.png"
import {gradeState, semesterState} from "../../recoil/lesson/lessonState";
import SideMenu from "../../components/SideMenu";
import HomeTop from "./components/HomeTop";
import {homeSubMenuState} from "../../recoil/home/homeState";
import { useLoadingSpinner } from "../../components/LoadingSpinner";

const HomePage = () => {
    const auth = useRecoilValue(authState);
    const teacherId = useRecoilValue(teacherIdState);
    //const [teacherId, setTeacherId] = useState(55);
    const [mainClass, setMainClass] = useRecoilState(mainClassState);
    const [studentsCount, setStudentsCount] = useState(null);
    const [grade, setGrade] = useRecoilState(gradeState);
    const [semester, setSemester] = useRecoilState(semesterState);
    const setTeacherGrade = useSetRecoilState(teacherGradeState);
    const setTeacherSemester = useSetRecoilState(teacherSemesterState);
    const [totalStageSemesterCount, setTotalStageSemesterCount] = useState(null);
    const [studyActiveStageSemesterCount, setStudyActiveStageSemesterCount] = useState(null);
    const [progressSemesterRate, setProgressSemesterRate] = useState(null);
    const [stagesCompletedLast2Weeks, setStagesCompletedLast2Weeks] = useState(null);
    const [completionRateLast2Weeks, setCompletionRateLast2Weeks] = useState(null);
    const [recentStageResults, setRecentStageResults] = useState(null);
    const navigate = useNavigate();
    const [displayCount, setDisplayCount] = useState(5); // 처음에는 5개만 표시
    
    // 로딩 스피너 훅 사용
    const { isLoading, setIsLoading, LoadingIndicator } = useLoadingSpinner();

    const [homeTab, setHomeTab] = useRecoilState(homeSubMenuState);

    const setMenuType = useSetRecoilState(topMenuTypeState);

    useEffect(() =>  {
        if(setMenuType){
            setMenuType("home");
        }
    },[setMenuType])

    const selectMenu = (selectedPath) =>{
        setMenuType(selectedPath);
        navigate("/page/"+selectedPath);
    }

    useEffect(() =>{
        if(homeTab==="homework"){
            navigate("/page/homeHomework");
        }
    },[homeTab])


    /**
     * 선택된 클래스 학생 리스트 가져오기
     * @param classId
     * @returns {Promise<void>}
     */
    const fetchHomeData = async () => {
        if(homeTab!=="lesson"){
            return;
        }
        setIsLoading(true); // 데이터 로딩 시작
        
        try {
            const body = {
                teacherId: teacherId
            };
            const res = await getHomeData(body);
            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                const data = res.data.data;
                setStudentsCount(data.studentsCount);
                setGrade(data.grade);
                setTeacherGrade(data.grade);
                setSemester(data.semester);
                setTeacherSemester(data.semester);
                setTotalStageSemesterCount(data.totalStageSemesterCount);
                setStudyActiveStageSemesterCount(data.studyActiveStageSemesterCount);
                setProgressSemesterRate(data.progressSemesterRate);
                setStagesCompletedLast2Weeks(data.stagesCompletedLast2Weeks);
                setCompletionRateLast2Weeks(data.completionRateLast2Weeks);
                setRecentStageResults(data.recentStageResults);
            }else if(statusCode === 'NoClass'){
                alert(`${res.data.status.message}`);
                navigate("/page/management?page=class");
            } else {
                alert(`ERROR: 학생 정보 로드중 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert(`[${error.message}]\n 학생 정보 로드중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        } finally {
            setIsLoading(false); // 데이터 로딩 완료
        }
    };

    useEffect(() => {
        if(teacherId && mainClass){
            fetchHomeData();
        }
    }, [teacherId, mainClass]);

    return (
        <div className="flex flex-col items-center w-full max-md:max-w-full bg-[#F8F8F8] min-h-screen">
            {/* 로딩 스피너 */}
            {LoadingIndicator}
            
            <div className="flex flex-col items-center justify-center w-full mt-[72px] gap-[9px]">
                <HomeTop
                    auth={auth}
                    mainClass={mainClass}
                    studentsCount={studentsCount}
                    selectMenu={selectMenu}
                    homeTab="lesson"
                    setHomeTab={setHomeTab}
                />
                <div className="max-w-[1044px] w-full mt-8">
                    <div className="flex flex-row justify-start items-end gap-[6px]">
                        <div className="text-[#50555F] text-[24px] font-[700]">
                            수업 진도율
                        </div>
                        <div className="text-[#868E9F] text-[16px] font-[500]">
                            (학교 학습-수업 기준)
                        </div>
                    </div>

                    <div
                        className="flex flex-row items-center w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] h-[78px] p-5 gap-3 mt-3">
                        <div
                            className="flex justify-center items-center text-black text-[18px] font-[500] h-[34px] p-2 w-[135px]">
                            {grade}학년 {semester}학기
                        </div>
                        <div
                            className="flex items-center w-full bg-[#EFEFEF] rounded-[10px] h-[34px]  text-center text-[#50555F] text-[14px] font-[500] relative">
                            <div className="absolute w-full text-center">
                                {studyActiveStageSemesterCount}/{totalStageSemesterCount}({progressSemesterRate}%)
                            </div>
                            <div className={`bg-[#A3C6FF] h-full rounded-l-[10px]`}
                                 style={{width: `${progressSemesterRate}%`}}></div>
                        </div>
                    </div>
                </div>

                <div className="max-w-[1044px] w-full mt-8">
                    <div className="flex flex-row justify-start items-end gap-[6px]">
                        <div className="text-[#50555F] text-[24px] font-[700]">
                            주간 수업 현황
                        </div>
                        <div className="text-[#868E9F] text-[16px] font-[500]">
                            (최근 2주 동안 수업한 학습)
                        </div>
                    </div>

                    <div
                        className="flex flex-row items-center w-full  h-[140px]  gap-5 mt-3">
                        <div
                            className="flex justify-between items-center  p-2  w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] px-[32px] py-[22px]">
                            <img
                                src={BoardImg}
                                alt="board icoo"
                                className="w-[100px]"
                            />
                            <div className="flex flex-col justify-end h-[100px]">
                                <div
                                    className="text-[#355BDF] text-[50px] font-[700] w-[130px] h-full text-right">{stagesCompletedLast2Weeks}<span
                                    className="text-[40px]">개</span></div>
                                <div className="text-black text-[22px] font-[700] w-[130px] h-full text-right">수업 진행
                                    개수
                                </div>
                            </div>
                        </div>
                        <div
                            className="flex justify-between items-center  p-2 w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] px-[32px] py-[22px]">
                            <img
                                src={OpenBookImg}
                                alt="memo img"
                                className="w-[100px]"
                            />
                            <div className="flex flex-col justify-end h-[100px]">
                                <div
                                    className="text-[#355BDF] text-[50px] font-[700] w-[130px] h-full text-right">{completionRateLast2Weeks}<span
                                    className="text-[40px]">%</span></div>
                                <div className="text-black text-[22px] font-[700] w-[130px] h-full text-right">학습 완료율
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="max-w-[1044px] w-full mt-8 mb-40">
                    <div className="flex flex-row justify-start items-center gap-[6px] mb-[12px] min-h-[44px]">
                        <div className="text-[#50555F] text-[24px] font-[700]">
                            최근 수업 현황
                        </div>
                        <div
                            className="flex w-[64px] h-[29px] justify-center items-center rounded-[130px] border-[2px] border-[#355BDF] text-[#355BDF] text-[18px] font-[700]">
                            {stagesCompletedLast2Weeks}개
                        </div>
                        <div className="text-[#868E9F] text-[16px] font-[500]">
                            (최근 2주 동안 수업한 학습)
                        </div>
                    </div>
                    {recentStageResults && recentStageResults.length > 0 ? (
                            <>
                                {recentStageResults.slice(0, displayCount).map((result, index) => (
                                    <HomeStageBadge
                                        key={index}
                                        grade={grade}
                                        semester={semester}
                                        stageSummary={result}
                                        classInfo={mainClass}
                                    />
                                ))}

                                {/* 더보기 버튼: 표시된 개수(displayCount)가 전체 개수보다 적을 경우만 표시 */}
                                {displayCount < recentStageResults.length && (
                                    <button
                                        onClick={() => setDisplayCount(displayCount + 5)}
                                    >
                                        <img src={ShowNextBtn}
                                             alt="show next btn"/>
                                    </button>
                                )}
                            </>
                        )
                        :
                        (
                            <>
                                <div
                                    className="flex flex-row items-center w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] h-[78px] p-5 gap-3 mt-3">
                                    <div
                                        className="flex justify-center items-center text-black text-[18px] font-[500] h-[34px] p-2 w-full">
                                        학습한 내역이 없습니다.
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
            <SideMenu></SideMenu>
        </div>
    );
}

export default HomePage;